import React from 'react';
import { CheckboxListSelector } from 'src/design/molecules/CheckboxListSelector';

interface IDivisionSelectorProps {
  onChange: (divisions: string[]) => void;
  value?: string[];
  options: string[];
  disabled?: boolean;
}

export const DivisionSelector: React.FC<IDivisionSelectorProps> = ({
  onChange,
  value = [],
  options,
  disabled = false,
}) => {
  return (
    <CheckboxListSelector
      items={options}
      value={value}
      onChange={onChange}
      getItemLabel={(item) => item}
      getItemId={(item) => item}
      label="Divisions"
      searchPlaceholder="Search divisions..."
      disabled={disabled}
      storageKey="manhours-division-selector"
      defaultToAll
    />
  );
};
